module.exports = __webpack_public_path__ + "img/29.367fc80e.jpg";